// extracted by mini-css-extract-plugin
export default {"top-section":"_tdbv8t","topSection":"_tdbv8t","app-icon":"_mka04l","appIcon":"_mka04l","wix-offering-icon":"_191ah15","wixOfferingIcon":"_191ah15"};